import React from 'react';

class LogoSVG extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <svg className="mole-logo-svg"  version="1.1" x="0px" y="0px" viewBox="0 0 192.3 60"  style={{'display': 'block'}}>
                <polygon style={{'--i': '0s'}} className="st0" points="28.9,24.9 10,0 0,0 0,60 8.5,60 8.5,12.3 28.9,38.6 49.3,12.3 49.3,60 57.8,60 57.8,0 47.9,0 	"/>
                <path style={{'--i': '1s'}}  className="st0" d="M92.1,16.6C80,16.6,71.3,26.1,71.3,38s8.8,21.4,20.8,21.4s20.8-9.5,20.8-21.4C113,26.1,104.2,16.6,92.1,16.6z
                    M92.1,51.7c-7.1,0-12.5-5.5-12.5-13.6S85,24.5,92.1,24.5s12.5,5.5,12.5,13.6S99.2,51.7,92.1,51.7z"/>
                <path style={{'--i': '2s'}}  className="st0" d="M138,51.8c-1.1,0-2.1-0.5-2.9-1.2c-0.7-0.7-1.2-1.8-1.2-2.9V23V0h-8.2v23v24.7c0,3.4,1.4,6.5,3.6,8.7
                    c2.2,2.2,5.3,3.6,8.7,3.6s6.4-1.4,8.7-3.6l-5.8-5.8C140.2,51.4,139.2,51.8,138,51.8z"/>
                <path style={{'--i': '3s'}}  className="st0" d="M192.3,39.9c0-16.5-9.2-23.2-18.9-23.2c-13.3,0-19.4,10.6-19.4,21.1v0.6c0,10.5,5.9,20.9,19.4,21.1
                    c7.1,0,14.3-3.4,18.6-10.8l-6.7-4.1c-2.5,4.5-6.1,7.6-11.9,7.6c-6.3,0-10.1-5.3-11.1-9.4c0,0-0.3-0.6-0.3-2.8L192.3,39.9
                    L192.3,39.9L192.3,39.9z M162.6,33.4c0.7-4.8,3.6-9.5,10.4-9.5c6,0,9.9,4.2,10.3,9.5H162.6z"/>
            </svg>
        );
    }
}
export default LogoSVG;



// WEBPACK FOOTER //
// ./src/components/inc/LogoSVG.js